export default "__VITE_ASSET__BeqUwOrB__"